import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import axios from "axios";
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Form } from 'react-bootstrap';
import toast from 'react-hot-toast';
import '../../style/AuthStyle.css';
import { AutoComplete } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import Compressor from 'compressorjs';
import { SERVER_API } from '../../fileWithConstants'
const UpdateFabric = () => {
  const [isUpdating, setIsUpdating] = useState(false);
  const params = useParams();
  const [fabricPhoto, setFabricPhoto] = useState("");
  const navigate = useNavigate();
  const [name, setName] = useState('');

  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [supplier, setSupplier] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState('');
  const [selectedPrimary, setSelectedPrimary] = useState('');
  const [selectedDye, setSelectedDye] = useState('');
  const [fabricStatus, setFabricStatus] = useState('');
  const [supplierfbname, setSupplierfbname] = useState('');
  const [fabrics, setFabrics] = useState([]);
  const [allFabrics, setAllFabrics] = useState([]);
  const [fabtype, setFabtype] = useState(0);
  const [option, setOption] = useState('');
  const [oldfabricPhoto, setOldfabricPhoto] = useState("");
  const [validated, setValidated] = useState(false);
  const [fbExist, setFbExist] = useState('');
  const [checkStatus, setCheckStatus] = useState(0);
  const [arz, setArz] = useState('');
  const [arzerror, setArzError] = useState("");

  const handleUpdate = async (e) => {
  e.preventDefault();
  const form = e.currentTarget;

  if (form.checkValidity() === false) {
    e.stopPropagation();
    setValidated(true);
    return;
  }

  setValidated(true);
  setIsUpdating(true); // ✅ Start loading

  try {
    const isNewImage = fabricPhoto && typeof fabricPhoto === "object";

    const formData = new FormData();
    formData.append("name", name);
    formData.append("supplierfbname", supplierfbname);
    formData.append("category", selectedCategory);
    formData.append("supplier", selectedSupplier);
    formData.append("dyeable", selectedDye);
    formData.append("primary_fabric", selectedPrimary);
    formData.append("fabric_status", fabricStatus);
    formData.append("oldfabricPhoto", oldfabricPhoto);
    formData.append("check_status", checkStatus);
    formData.append("arz", arz);

    if (isNewImage) {
      formData.append("fabric_photo", fabricPhoto);
    } else {
      formData.append("fabric_photo", fabricPhoto || "");
    }

    const { data } = await axios.put(
      `${SERVER_API}/api/v1/fabric/update-fabric/${params.fid}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (data?.success) {
      toast.success(data.message || "Fabric updated successfully!");
      window.location.reload();
    } else {
      toast.error(data.message || "Failed to update fabric.");
      setIsUpdating(false); // ✅ Stop loading if failed
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    toast.error("Something went wrong!");
    setIsUpdating(false); // ✅ Stop loading on error
  }
};


  const getAllSupplier = async () => {
    try {
      const { data } = await axios.get(`${SERVER_API}/api/v1/supplier/get-all-supplier`);
      if (data?.success && data?.suppliers?.length > 0) {
        setSupplier(data?.suppliers)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getAllFabricCategory = async () => {
    try {
      const { data } = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-category`);
      if (data?.success) {
        setCategory(data?.category)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getAllFabric = async () => {
    try {
      const { data } = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabricdata/0/1/1`);
      if (data?.success) {
        const fb_main_arr = data?.fabrics;
        setAllFabrics(fb_main_arr);
        const fab_names = fb_main_arr.map((fab) => fab.name)
        setFabrics(fab_names);
      }
    } catch (error) {
      console.log(error)
    }
  }

  const singleFabricData = async () => {
    try {
      const { data } = await axios.get(`${SERVER_API}/api/v1/fabric/get-main-fabric-data/${params.fid}`)
      if (data?.success) {
        console.log(data.fabric)
        setName(data.fabric[0]?.name)
        setSupplierfbname(data.fabric[0]?.supplierfbname)
        setSelectedCategory(data.fabric[0]?.category);
        setSelectedSupplier(data.fabric[0]?.supplier);
        setSelectedDye(data.fabric[0]?.dyeable);
        setSelectedPrimary(data.fabric[0]?.primary_fabric);
        setFabricPhoto(data.fabric[0]?.fabric_photo)
        setOldfabricPhoto(data.fabric[0]?.fabric_photo)
        setCheckStatus(data.fabric[0]?.check_status)
        setFabricStatus(data.fabric[0]?.fabric_status)
        setArz(data.fabric[0]?.arz)
      }

    } catch (error) {
      console.log(error)
    }
  }

  const getFabricData = async (item) => {
    //console.log(item)
    const f_code = await allFabrics.filter((fab) => fab.name === item).map((f) => f);
    //console.log(f_code)
    if (f_code?.length > 0) {

      setFabtype(f_code[0].id)
      setOption(' readonly');
      setSelectedCategory(f_code[0].category);
      setSelectedSupplier(f_code[0].supplier);
      setSelectedDye(f_code[0].dyeable);
      setFabricStatus(f_code[0].fabric_status);
    } else {
      setFabtype(0)
      setOption('');
      setSelectedCategory("");
      setSelectedSupplier("");
      setSelectedDye("");
    }
  }

  useEffect(() => {
    getAllFabric();
    getAllFabricCategory();
  }, [])

  useEffect(() => {
    getAllSupplier();
  }, [])
  useEffect(() => {
    singleFabricData();
  }, [params.fid])

  const onFileChange = (e) => {
    setFabricPhoto(e.target.files[0]);
  };

  const cancelHandle = () => {
    navigate('/dashboard/fabric-list');
  }

  const handleChangeCheck = (e) => {
    setCheckStatus(e.target.checked ? 1 : 0);
  }

  const handleArzChange = (e) => {
    const val = e.target.value;
    if (/^\d{0,2}$/.test(val)) {
      setArz(val);

      // validation: must be exactly 2 digits
      if (val.length === 2) {
        setArzError("");
      } else {
        setArzError("Arz must be exactly 2 digits");
      }
    }
  };

  return (
    <Layout title={'Update Fabric'}>

      <div className='form-container'>
        <Form onSubmit={handleUpdate} encType="multipart/form-data" className='form-section'>
          <h4 className='title'>Update Fabric</h4>
          <div className='form-box'>
            <div className="mb-3">
              <label>Fabric Name*</label>
              <AutoComplete data={fabrics}
                name='name'
                value={name}
                onPaste={(e) => {
                  e.preventDefault();
                  return false;
                }}
                onChange={(value, e) => { setName(value); }} defaultValue="" onSelect={(item, e) => getFabricData(item)} />
              <p className='text-danger text-bold'>{fbExist}</p>
              <input name="fabtype" value={fabtype} type="hidden" />
            </div>

            <div className="mb-3">
              <label>Supplier Fabric Name</label>
              <input type="text"
                className="form-control"
                value={supplierfbname}
                name='supplier_fbname'
                onChange={(e) => setSupplierfbname(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label>Choose Category*</label>
              <select value={selectedCategory} required className="form-select selectpicker form-control" readOnly={option} name='category' onChange={(e) => setSelectedCategory(e.target.value)}>
                <option value={""}>--Select--</option>
                {category?.map((c, index) => (
                  <option value={c.id} key={index}>{c.name}</option>
                ))}
              </select>
            </div>


            <div className="mb-3">
              <label>Supplier*</label>
              <select value={selectedSupplier} required className="form-select form-control" readOnly={option} name='supplier' onChange={(e) => setSelectedSupplier(e.target.value)}>
                <option value={""}>--Select--</option>
                {supplier?.map((s, index) => (
                  <option value={s.v_id} key={index}>{s.code}</option>
                ))}
              </select>
            </div>
            
            <div className="mb-3">
              <label>Primary Fabric*</label>
              <select value={selectedPrimary} required className="form-select form-control" readOnly={option} name='primary_fabric' onChange={(e) => setSelectedPrimary(e.target.value)}>
                <option value={""}>--Select--</option>
                <option value={"1"}>Yes</option>
                <option value={"0"}>No</option>
              </select>
            </div>
            <div className="mb-3">
              <label>Dyeable*</label>
              <select value={selectedDye} required className="form-select form-control" readOnly={option} name='dyeable' onChange={(e) => setSelectedDye(e.target.value)}>
                <option value={""}>--Select--</option>
                <option value={"1"}>Yes</option>
                <option value={"0"}>No</option>
              </select>
            </div>

            <div className="mb-3">
              <label>Fabric Status*</label>
              <select value={fabricStatus} required className="form-select form-control" name='fabric_status' onChange={(e) => setFabricStatus(e.target.value)}>
                <option value={""}>--Select--</option>
                <option value={"1"}>Continue</option>
                <option value={"0"}>Discontinue</option>
              </select>
            </div>

            <div className="mb-3">
              <label>Picture Upload </label>
              <Link to={`${SERVER_API}/uploads/fabrics/${oldfabricPhoto}`} target='_blank'>
                <img
                  src={`${SERVER_API}/uploads/fabrics/${oldfabricPhoto}`}
                  alt={name}
                  width="50"
                  style={{ padding: "10px" }}
                />
              </Link>
              <input className="form-control" name='fabric_photo' type="file" accept="image/png, image/jpg, image/jpeg" onChange={onFileChange} />
            </div>

            <div className="mb-3">
              <label>Arz*</label>
              <input
                type="text"
                className={`form-control ${arzerror ? "is-invalid" : ""}`}
                value={arz}
                name="arz"
                onChange={handleArzChange}
                maxLength={2}
                style={{ width: "40px" }}
                required
              />
              {arzerror && <div className="invalid-feedback">{arzerror}</div>}
            </div>

            <div className="mb-3 mt-10 text-right">
              <input type='checkbox' name='check_status' checked={checkStatus === 1} onChange={handleChangeCheck} /> Check Status
            </div>

            <div className='row'>
              <div className='col-6'>
              <button
                type="submit"
                className="btn btn-success form-control"
                disabled={isUpdating}
              >
                {isUpdating ? "Updating..." : "Update"}
              </button>

              </div>
              <div className='col-6'> <button type="button" onClick={cancelHandle} className="btn btn-dark form-control">Back</button></div>
            </div>

          </div>

        </Form>
      </div>
    </Layout>
  )
}

export default UpdateFabric
